export const CLOSED = 0;
export const OFFER_LATER = 1;
export const ON_OFFER = 2;
